var _path, _rect, _rect2, _rect3, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMesManagementError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 25H52V56H50V58H52C53.1046 58 54 57.1046 54 56V25C54 23.8954 53.1046 23 52 23H8C6.89543 23 6 23.8954 6 25V56C6 57.1046 6.89543 58 8 58H43V56H8V25Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 56,
    width: 43,
    height: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 56,
    width: 9,
    height: 2,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 9,
    height: 13,
    fill: "#FA4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4V7H18V4H11ZM9 7V9V12V14V18C9 18.5523 9.44771 19 10 19H19C19.5523 19 20 18.5523 20 18V14V12V9V7V3C20 2.44772 19.5523 2 19 2H10C9.44772 2 9 2.44772 9 3V7ZM18 12V9H11V12H18ZM11 14V17H18V14H11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H17V24H12L12 18Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 45V31H23V45H14ZM25 47H23H13C12.4477 47 12 46.5523 12 46V30C12 29.4477 12.4477 29 13 29H23H25H35C35.5523 29 36 29.4477 36 30V46C36 46.5523 35.5523 47 35 47H25ZM25 31H34V45H25V31ZM19 37C19 36.4477 19.4477 36 20 36C20.5523 36 21 36.4477 21 37V39C21 39.5523 20.5523 40 20 40C19.4477 40 19 39.5523 19 39V37ZM28 36C27.4477 36 27 36.4477 27 37V39C27 39.5523 27.4477 40 28 40C28.5523 40 29 39.5523 29 39V37C29 36.4477 28.5523 36 28 36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMesManagementError);
export default __webpack_public_path__ + "static/media/icon-mes-management-error.5b49e13e23fd808f61aa5ae5914f9a97.svg";
export { ForwardRef as ReactComponent };